/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermDto } from '../../models/term-dto';

export interface TermControllerFindByType$Params {
  type: string;
}

export function termControllerFindByType(http: HttpClient, rootUrl: string, params: TermControllerFindByType$Params, context?: HttpContext): Observable<StrictHttpResponse<TermDto>> {
  const rb = new RequestBuilder(rootUrl, termControllerFindByType.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermDto>;
    })
  );
}

termControllerFindByType.PATH = '/api/term/{type}';
